import { collection, getDocs } from 'firebase/firestore';

import { FSCollections } from '@src/constants/database';
import { db } from '@src/firebase/firebase';
import type {
  CreateTotemParams,
  RevokeTotemParams,
  TotemFirestoreRecord,
} from '@src/models/interfaces/totem.interface';
import { getDocData } from '@src/packages/utils';
import { apiCallable } from '@src/util/cloud-functions/apiClient';
import { API_OPERATIONS } from '@src/util/cloud-functions/operations';

export interface TotemFirestoreListItem {
  id: string;
  record: TotemFirestoreRecord;
}

class TotemRepository {
  private organizationCollection = FSCollections.ORGANIZATIONS;
  private totemsCollection = FSCollections.TOTEMS;

  async listByOrganizationId(organizationId: string): Promise<TotemFirestoreListItem[]> {
    if (!organizationId) {
      return [];
    }

    const collectionRef = collection(
      db,
      this.organizationCollection,
      organizationId,
      this.totemsCollection,
    );
    const snapshot = await getDocs(collectionRef);

    return snapshot.docs.map(docSnap => ({
      id: docSnap.id,
      record: getDocData(docSnap) as TotemFirestoreRecord,
    }));
  }

  async create(params: CreateTotemParams): Promise<void> {
    const createTotemFn = apiCallable<CreateTotemParams, void>(
      API_OPERATIONS.CREATE_TOTEM,
    );
    await createTotemFn(params);
  }

  async revoke(params: RevokeTotemParams): Promise<void> {
    const revokeTotemFn = apiCallable<RevokeTotemParams, void>(
      API_OPERATIONS.REVOKE_TOTEM,
    );
    await revokeTotemFn(params);
  }
}

export default TotemRepository;
